import React from 'react'
import { Wrapper } from './Retencion.styles'
import Main from 'src/components/common/Main/Main'
import { GridContainer, GridItem } from 'src/components/common/grids'
import Tabs from '../common/TabSwich/Tabs'
import { configFile } from './Retention.constants'

const Retention = () => {

    return (
        <Main>
            <Wrapper>
                <GridContainer className='container'>
                    <GridItem lg={12}>
                        <Tabs configFile={configFile} className='retention-tabs' />
                    </GridItem>
                </GridContainer>
            </Wrapper>
        </Main>
    )
}

export default Retention